import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IAbstractRecord } from '@models';
import PrecisionService from '@services/PrecisionService';

export const getPolicyPlanCoverInputs = (
  data: IAbstractRecord
): IDynamicFormWidgetSection[] => {
  const amendmentCoverPremiumType = data?.AmendmentCoverPremiumType;
  const amendmentExcessOnClaimType = data?.AmendmentExcessOnClaimType;
  return [
    {
      inputs: {
        SumInsuredVariance: {
          name: 'SumInsuredVariance',
          title: 'Sum Insured Variance',
          placeholder: 'Sum Insured Variance',
          type: FormFieldType.currency,
          required: true,
          value: data?.AmendmentCoverSumInsured ?? 0,
          allowNegative: true,
        },
        PremiumValueVariance: {
          name: 'PremiumValueVariance',
          title: 'Premium Value Variance',
          placeholder: 'Premium Value Variance',
          type: FormFieldType.currency,
          hidden: amendmentCoverPremiumType != 'VALUE',
          required: amendmentCoverPremiumType === 'VALUE',
          value: data?.AmendmentCoverPremiumValue ?? 0,
          allowNegative: true,
        },
        PremiumPercentageVariance: {
          name: 'PremiumPercentageVariance',
          title: 'Premium Percentage Variance',
          placeholder: 'Premium Percentage Variance',
          type: FormFieldType.percentage,
          hidden: amendmentCoverPremiumType != 'PERCENTAGE',
          required: amendmentCoverPremiumType === 'PERCENTAGE',
          value: PrecisionService.multiplyBy100(
            data?.AmendmentCoverPremiumPercentage ?? 0
          ),
        },
        ExcessPercentageVariance: {
          name: 'ExcessPercentageVariance',
          title: 'Excess On Claim Percentage Variance',
          placeholder: 'Excess On Claim Percentage Variance',
          type: FormFieldType.percentage,
          hidden: amendmentExcessOnClaimType != 'PERCENTAGE',
          required: amendmentExcessOnClaimType === 'PERCENTAGE',
          value: PrecisionService.multiplyBy100(
            data?.AmendmentExcessOnClaimPercentage ?? 0
          ),
        },
        ExcessValueVariance: {
          name: 'ExcessValueVariance',
          title: 'Excess On Claim Variance',
          placeholder: 'Excess On Claim Variance',
          type: FormFieldType.currency,
          hidden: amendmentExcessOnClaimType != 'VALUE',
          required: amendmentExcessOnClaimType === 'VALUE',
          value: data?.AmendmentExcessOnClaimAmount ?? 0,
          allowNegative: true,
        },
        ExcessDaysVariance: {
          name: 'ExcessDaysVariance',
          title: 'Excess On Claim Variance',
          placeholder: 'Excess On Claim Variance',
          type: FormFieldType.number,
          hidden: amendmentExcessOnClaimType != 'DAYS',
          required: amendmentExcessOnClaimType === 'DAYS',
          value: data?.AmendmentExcessOnClaimDays ?? 0,
        },
      },
    },
  ];
};
